import React, { useRef, useState, useEffect } from "react";
import "@/App.css";
import { useLenis } from "@/hooks/useLenis";
import Loader from "@/components/site/Loader";
import CustomCursor from "@/components/site/CustomCursor";
import Navigation from "@/components/site/Navigation";
import Hero from "@/components/site/Hero";
import Manifesto from "@/components/site/Manifesto";
import Marquee from "@/components/site/Marquee";
import Experience from "@/components/site/Experience";
import Projects from "@/components/site/Projects";
import Skills from "@/components/site/Skills";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import PersistentCat from "@/components/site/PersistentCat";
import InlineMinigame from "@/components/site/InlineMinigame";
import GameDoors from "@/components/site/GameDoors";
import AdminPanel from "@/components/site/AdminPanel";
import { LangSwitcher } from "@/i18n";

function App() {
  const [, setReady] = useState(false);
  useLenis();
  const catRef = useRef({ x: 0, y: 0, w: 0, h: 0 });
  const [openSignal, setOpenSignal] = useState(null);

  // Prevent the Space key from scrolling the page to the bottom anywhere,
  // unless the focus is on an editable/interactive element.
  useEffect(() => {
    const onKey = (e) => {
      if (e.code !== "Space") return;
      const el = document.activeElement;
      const tag = el && el.tagName;
      const editable =
        el &&
        (el.isContentEditable ||
          ["INPUT", "TEXTAREA", "SELECT", "BUTTON", "A"].includes(tag));
      if (!editable) e.preventDefault();
    };
    window.addEventListener("keydown", onKey, { passive: false });
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <div className="App" data-testid="app-root">
      <Loader onDone={() => setReady(true)} />
      <CustomCursor />
      <LangSwitcher />
      <AdminPanel />
      <Navigation />
      <PersistentCat catRef={catRef} openGameSignal={openSignal} />
      <GameDoors
        catRef={catRef}
        onOpen={(id) => setOpenSignal({ id, ts: Date.now() })}
      />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Experience />

        <InlineMinigame
          id="pour"
          chapter="Ara · Stüdyo ritüeli"
          title="Kusursuz Dem"
          intro="Studio Ünlü'de her teslimat bir espresso ile başlar. İşaretçiyi altın bandın içinde durdur — üç tur, üç yıldız."
          kind="pour"
          bg="var(--paper)"
          config={{
            title: "Kusursuz Dem",
            intro: "Dökmek için Boşluk tuşunu basılı tut. Köpük altın banda gelince bırak.",
            reward: "Kusursuz bir espresso demledin ☕",
          }}
        />

        <Projects />

        <InlineMinigame
          id="grid-match"
          chapter="Ara · Akış"
          title="Grid Eşleştir"
          intro="Sosyal takvim, teslim tarihli bir hafıza oyunudur. Dört çift kartın hepsini eşleştir — daha az açış, daha sağlıklı bir etkileşim oranı."
          kind="match"
          bg="var(--bone-soft)"
          config={{
            title: "Grid Eşleştir",
            intro: "Kartları ikişer ikişer çevir. Daha az açış = daha iyi bir akış.",
            reward: "Grid yeniden düzenlendi. Etkileşim +5,3×",
            size: 4,
          }}
        />

        <Skills />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
